export const questionsData = [
    {
        id: 1,
        ru: {
            title: 'Почему стоит выделить CSGORace среди других сайтов?',
            answer: 'CSGORace - это первый тематический сайт в CS:GO гемблинге. Если вам нравится скорость и тематика гонок, то наш сайт непременно удовлетворит вас своей атмосферой и различными режимами в особом стиле.',
        },
        en: {
            title: 'Why should you choose CSGORace among others?',
            answer: 'CSGORace is the first dedicated to races CS:GO gambling website. If you are amazed by speed and cars, our website will give you an outstanding experience with its atmosphere and stylized game modes.',
        },
        open: false
    },
    {
        id: 2,
        ru: {
            title: 'Я нашел баг',
            answer: 'Если вы нашли какой-то баг, то обязательно обратитесь в техподдержку с четким описанием. Если баг подтвердится - вы получите вознаграждение в зависимости от серьезности бага. Напоминаем, что пользоваться уязвимостями на нашем сайте запрещено.В таком случае вам стоит обратиться в техподдержку с данным вопросом, где наши операторы помогут вам в решении этого вопроса.',
        },
        en: {
            title: 'I have found a bug',
            answer: 'If you have found a bug, you should immediately contact our support team with detailed info. If the bug is confirmed, you will receive some reward depending on the severity of this bug. We want to emphasize that exploiting bugs is strictly prohibited.',
        },
        open: false
    },
    {
        id: 3,
        ru: {
            title: 'Что делать, если трейд со скином не приходит более 10 минут?',
            answer: 'В таком случае вам стоит обратиться в техподдержку с данным вопросом, где наши операторы помогут вам в решение этого вопроса.',
        },
        en: {
            title: 'What should I do if a trade didn’t show up in more than 10 minutes?',
            answer: 'You should contact our support team and then they will help you to sort it out.',
        },
        open: false
    },
    {
        id: 4,
        ru: {
            title: 'Депозит не проходит',
            answer: 'Депозиты проводятся, как правило, в течение 3 минут, но иногда бывают задержки до 60 минут.',
        },
        en: {
            title: 'The website does not see my deposit',
            answer: 'Deposits usually are accounted for in 3 minutes, but sometimes it takes nearly 60 minutes.',
        },
        open: false
    },
    {
        id: 5,
        ru: {
            title: 'Мой аккаунт заблокирован',
            answer: 'Скорее всего вы нарушили какое-то из наших правил сайта, рекомендуем в таком случае написать в техподдержку.',
        },
        en: {
            title: 'My account was blocked',
            answer: 'In most cases, it happens because you have broken the rules of our website, but if you are confident, it is a mistake, you should contact our support team to sort it out.',
        },
        open: false
    },
    {
        id: 6,
        ru: {
            title: 'Как считается уровень?',
            answer: 'Уровень считается исходя из ваших ставок, которые конвертируются в опыт (xp). За каждую поставленную Капельку в режиме Race вы получаете 200xp , а в остальных режимах — 1000xp. Информацию о том, сколько xp вам нужно до следующего уровня, можно узнать в профиле.',
        },
        en: {
            title: 'How does the level get calculated?',
            answer: 'Your level is based on the number of your bets, which then are converted in xp. For each Drop of Fuel, you bet on Race mode you receive 200xp and on other modes – 1000xp. If you want to find out how many xp you need to level up, you can check it out in your profile.',
        },
        open: false
    },
    {
        id: 7,
        ru: {
            title: 'Как стать партнёром?',
            answer: 'Для того, чтобы стать нашим партнером, вам нужно иметь от 10 000 просмотров на видео в YouTube или иметь порядка 100 зрителей онлайн на Twitch. Ждем ваших предложений - commercial@csgorace.com.',
        },
        en: {
            title: 'How can I become a partner?',
            answer: 'To become our partner, you need to have at least 10000 views on each video on YouTube or an average of 100 viewers online on Twitch. If you meet these criteria, you can contact us via the email: commercial@csgorace.com.',
        },
        open: false
    },
    {
        id: 8,
        ru: {
            title: 'Является ли результат раунда полностью рандомным?',
            answer: 'Да, ведь мы используем систему хэширования, то есть у нас сгенерированы хэши по протоколу sha256 на 2 миллиона раундов вперёд. Хэши мы используем поочередно в обратной последовательности. Они дополнительно обновляются перед номером раунда и временем, когда он начался, чтобы даже мы не могли знать результаты раундов наперед. Данные о раунде вы можете найти в истории раундов в профиле.',
        },
        en: {
            title: 'Is the result of the round completely random?',
            answer: 'Yes, it is completely random because of our hash system. In other words, we have pre-generated hashes for 2 million rounds in advance using the sha256 algorithm. For each round, we use one of them in the reverse order. Moreover, every hash is updated by the round ID and date of its start, so even we don’t know the results in advance because it is impossible to guess when the round will start. Information about the round you can find in your profile in the round history section.',
        },
        open: false
    },
    {
        id: 9,
        ru: {
            title: 'Можно ли отменить ставку?',
            answer: 'Нет, к сожалению, ставки невозможно отменить  из-за правил нашего сайта.Будьте бдительны, когда делаете ставку.',
        },
        en: {
            title: 'How can I cancel my bet?',
            answer: 'It is impossible to cancel your bet because of the rules of our site. Be careful while making a bet.',
        },
        open: false
    },
    {
        id: 10,
        ru: {
            title: 'Что такое Free Fuel?',
            answer: 'Это - ежедневный бонус, размер которого зависит от вашего уровня. Чем больше ваш уровень, тем больше машинок вам доступно для заезда. Раз в день вы можете запустить по одной машинке.',
        },
        en: {
            title: 'What is Free Fuel?',
            answer: 'Free fuel is a special daily bonus, the amount of which depends on your level. The higher your level is, the more cars are available for a race. Each day you can race each car only once.',
        },
        open: false
    },
    {
        id: 11,
        ru: {
            title: 'Как мне сменить мою машинку в профиле?',
            answer: 'Автомобиль обновляется в соответствии с вашим уровнем.  Чем больше вы играете на сайте, тем лучше будет ваша машинка.',
        },
        en: {
            title: 'How can I change my car in the profile?',
            answer: 'Car updates accordingly to your level. The more you play, the better car you own.',
        },
        open: false
    },
    {
        id: 12,
        ru: {
            title: 'Как получить промо-код?',
            answer: 'Промокоды раздаются администрацией в наших социальных сетях или во время интеграций с блогерами, обычно количество активаций промокодов ограничено.',
        },
        en: {
            title: 'Where can I get a promo code?',
            answer: 'Promo Codes are dropped by our PR department on our social networks accounts or during integrations with bloggers. Usually, the number of activations is limited.',
        },
        open: false
    }
]